<template>
  <div v-bind:class="{ 'version-spacing': !isLoggedIn }">
    <PageHeader title="Log In"></PageHeader>
      <v-container class="page-bottom">
        <v-row>
          <v-col>
            <v-form
              ref="form"
              v-model="valid"
              lazy-validation
              @submit.prevent="validate"
              id="frmLogin"
            >
              <v-text-field
                v-model="user.userName"
                :rules="[rules.required]"
                label="User name or Email"
                required
              ></v-text-field>

              <v-text-field
                v-model="user.password"
                :rules="[rules.required]"
                :type="showPass ? 'text' : 'password'"
                label="Password"
                autocomplete="on"
              >
                <v-icon slot="append" color="white" @click="showPass = !showPass">
                  {{showPass ? 'mdi-eye' : 'mdi-eye-off'}}
                </v-icon>
              </v-text-field>

              <v-checkbox 
                v-model="keepLoggedIn"
                >
                  <template v-slot:label>
                    <div>
                      Keep me logged in
                    </div>
                  </template>
              </v-checkbox>

              <v-btn
                block
                outlined
                large
                style="color: #ffffff !important;border: 1px solid #ffb300;"
                :disabled="!valid"
                color="success"
                class="mt-5"
                type="submit"
                id="click-login"
              >
                Log In
              </v-btn>
            </v-form>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <router-link :to="{name: 'join'}">Not joined, Join here</router-link>
          </v-col>
          <v-col class="text-right">
            <router-link :to="{name: 'reset-password'}">Reset password</router-link>
          </v-col>
        </v-row>
      </v-container>

    <v-snackbar
      v-model="snackbar"
      :multi-line="true"
      centered
      color="error"
      id="snackbarLogin"
    >
      {{ snackbarText }}

      <template v-slot:action="{ attrs }">
        <v-btn
          color="white"
          text
          v-bind="attrs"
          @click="snackbar = false"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>      
    <Spinner :overlay="overlay"></Spinner>
  </div>
</template>

<script>
import { AuthenticationDetails, CognitoUser } from "amazon-cognito-identity-js";
import axios from 'axios';
import jwt_decode from "jwt-decode";
import PageHeader from './../../components/PageHeader';
import Spinner from './../../components/Spinner';
import UserPool from "./../../plugins/UserPool";
//import Socket from "./../../plugins/socket";

export default {
  name: 'login',
  components: {
    PageHeader,
    Spinner
  },
  data: () => ({
    valid: true,
    showPass: false,
    user: {
      userName: '',
      password: ''
    },
    keepLoggedIn: false,
    rules: {
      required: value => !!value || 'Required.'
    },
    overlay: false,
    absolute: true,
    snackbar: false,
    snackbarText: ''
  }),
  computed: {
    isLoggedIn () {
      return this.$store.getters.isLoggedIn;
    }
  },
  methods: {
    validate () {
      var scope = this;
      var isValid = scope.$refs.form.validate();
      if(isValid){
        scope.overlay = true;
        scope.login();
      }
    },
    login () {
      var scope = this;
      scope.overlay = true;

      var cognitoUser = new CognitoUser({
        Username: scope.user.userName,
        Pool: UserPool
      });

      const authDetails = new AuthenticationDetails({
        Username: scope.user.userName,
        Password: scope.user.password
      });

      cognitoUser.authenticateUser(authDetails, {
        onSuccess: (data) => {
          console.log("Success");
          scope.$localStorage.set('jwtToken', data.idToken.jwtToken);
          var decodedJwt = jwt_decode(data.idToken.jwtToken);
          
          axios.get('https://rhsrnact8d.execute-api.us-east-2.amazonaws.com/dev/users?sub=' + decodedJwt.sub, {
            headers: {
              'Authorization': localStorage.getItem('jwtToken')
            }
          })
            .then(function (response) {

              var loggedInUser = response.data;
              var userSub = {
                id: loggedInUser.id,
                sub: decodedJwt.sub,
                firstName: loggedInUser.firstName,
                surname: loggedInUser.surname,
                userName: loggedInUser.userName,
                role: loggedInUser.role,
                adminClubId: loggedInUser.adminClubId,
                adminClubName: loggedInUser.adminClubName,
                adminClubLogo: loggedInUser.adminClubLogo
              };
              scope.$localStorage.set('userSub', JSON.stringify(userSub));
              scope.$store.commit('setUserSub', userSub);
              scope.$store.commit('setIsLoggedIn', true);
              scope.$store.commit('setJwtToken', data.idToken.jwtToken);
              
              // scope.$store.dispatch('sendMessage', `{"action":"setUsername", "username": "${userSub.userName}"}`);
              // Socket.send(JSON.stringify({
              //   action: "setUsername",
              //   username: userSub.userName
              // }));

              axios.get('https://rhsrnact8d.execute-api.us-east-2.amazonaws.com/dev/wallets?userId=' + loggedInUser.id, {
                headers: {
                  'Authorization': localStorage.getItem('jwtToken')
                }
              })
                .then(function (response2) {

                  var localWallet = response2.data[0];
                  var newWallet = {
                    id: localWallet.id,
                    balance: localWallet.balance,
                    honeyPointsBalance: localWallet.honeyPointsBalance,
                    expectedBalance: localWallet.balance,
                    expectedHoneyPointsBalance: localWallet.honeyPointsBalance
                  };
                  scope.$localStorage.set('wallet', JSON.stringify(newWallet));
                  scope.$store.commit('setWallet', newWallet);
                  scope.overlay = false;
                  if(scope.$route.query.redirect && scope.$store.getters.redirectLink !== null) {
                    scope.$router.push(scope.$store.getters.redirectLink);
                    scope.$store.commit('setRedirectLink', null);
                  } else {
                    scope.$router.push({name: 'active-competitions'});
                  }
                })
                .catch(function (error) {
                  scope.overlay = false;
                  console.log(error);
                });

            })
            .catch(function (error) {
              scope.overlay = false;
              console.log(error);
            });
        },
        onFailure: (err) => {
          console.log("onFailure: ", err);
          scope.overlay = false;
          scope.snackbarText = err.message;
          scope.snackbar = true;
        }
      });
    }
  },
  created () {
    this.$store.commit('setShowSlideMenu', '');
  }
}
</script>